<template>
  <div v-if="isShow" style="width: 100%; height: 100%">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
  <div v-else></div>
</template>

<script>
import cookie from "@/utils/cookie";
export default {
  data() {
    return {
      srcList: [],
      active: "",
      token: cookie.getToken(),
      isShow: false,
    };
  },
  created() {
    if (
      this.$router.path == "/Microfront" ||
      this.$router.path == "/systemMicrofront"
    ) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  watch: {
    $route(to, from) {
      // this.setIfame(to);
      if (to.path == "/Microfront" || to.path == "/systemMicrofront") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
  },
  methods: {
    // setIfame(to) {
    //   if (to.path == "/Microfront") {
    //     this.showIfame = true;
    //     const url = window.baseConfig.configurationUrl + to.query.url;
    //     const item = this.srcList.find((obj) => obj === url);
    //     if (item) {
    //       this.active = url;
    //     } else {
    //       this.srcList.push(url);
    //       this.active = url;
    //     }
    //   }
    //   else if(to.path == "/systemMicrofront"){
    //     this.showIfame = true;
    //     const url = window.baseConfig.systemUrl + to.query.url;
    //     const item = this.srcList.find((obj) => obj === url);
    //     if (item) {
    //       this.active = url;
    //     } else {
    //       this.srcList.push(url);
    //       this.active = url;
    //     }
    //   } else {
    //     this.showIfame = false;
    //   }
    // },
  },
};
</script>

<style>
</style>